/**
 * Global fetch interceptor — catches 403 lockout responses on any API call
 * and force-redirects banned/suspended users to the appropriate lockout page.
 *
 * Wraps window.fetch ONCE at app startup. Idempotent — won't double-wrap if
 * imported twice.
 */

if (typeof window !== 'undefined' && !window.__darijaLockoutInstalled) {
  window.__darijaLockoutInstalled = true;
  const _origFetch = window.fetch.bind(window);

  window.fetch = async function (...args) {
    const response = await _origFetch(...args);

    // Only inspect 403 responses, and only on /api/ paths
    if (response.status === 403) {
      const url = (args[0] && (args[0].url || args[0])) || '';
      if (typeof url === 'string' && url.includes('/api/')) {
        // Avoid breaking the original response stream — clone before reading
        try {
          const cloned = response.clone();
          const data = await cloned.json();
          const detail = data && data.detail;
          if (detail && typeof detail === 'object' && (detail.code === 'banned' || detail.code === 'suspended')) {
            // Already on the matching lockout page? Don't loop.
            const target = detail.code === 'banned' ? '/account-banned' : '/account-suspended';
            if (window.location.pathname !== target) {
              try { sessionStorage.setItem('lockout_info', JSON.stringify(detail)); } catch {}
              // Clear local auth so subsequent loads don't re-attempt
              try {
                localStorage.removeItem('user_token');
                localStorage.removeItem('admin_token');
              } catch {}
              window.location.href = target;
            }
          }
        } catch {
          // Body wasn't JSON or couldn't be parsed — ignore, return original response
        }
      }
    }

    return response;
  };
}

export {};
